import { colorName, getFormattedDate } from "../../../helpers";
import { Piezometri } from "../components/macro/Piezometri";
import Header from "../components/micro/Header";
import { Info } from "../components/micro/Info";
import { List } from "../components/micro/List";
import { Next } from "../components/micro/Next";
import { Page } from "../components/micro/Page";
import { Table } from "../components/micro/Table";
import Topbar from "../components/micro/Topbar";
import { Tr } from "../components/micro/Tr";

export function SondaggiPage({
    onBack,
    lv0, lv1, lv2,
    listLv3,
    onMouseEnterRow,
    onMouseLeaveRow,
    onClickRow,
    hoverLv3
}) {

    const sondaggi = listLv3?.filter(item => item.tipo !== 'Piezómetro')
    const piezometri = listLv3?.filter(item => item.tipo === 'Piezómetro').map(p => ({
        ...p,
        name: p.nome
    }))

    const piezometro = id => piezometri.find(p => p.id === id)

    return (
        <Page>
            <Topbar onBack={onBack}>Sondaggi</Topbar>
            <Header
                lv0={lv0 ? lv0.nome : null}
                lv1={lv1 ? lv1.siglaMacrolotto + (lv1.descrizione ? " - " + lv1.descrizione : "") : null}
                lv2={lv2 ? lv2.nome : null}
            />
            <List>
                <Table>
                    <thead>
                        <tr>
                            <th>Sondaggio</th>
                            <th>Data prelievo</th>
                            <th>Profondità max</th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {sondaggi && sondaggi.map((sondaggio, i) =>
                            <Tr
                                key={i}
                                color={colorName(sondaggio.coloreSondaggio)}
                                onMouseEnter={() => onMouseEnterRow(sondaggio)}
                                onMouseLeave={() => onMouseLeaveRow()}
                                onClick={() => onClickRow(sondaggio)}
                                isHover={hoverLv3 && hoverLv3.id === sondaggio.id}
                            >
                                <td>{sondaggio.siglaSondaggio}</td>
                                <td>{getFormattedDate(sondaggio.prelievo_datetime)}</td>
                                <td>{sondaggio.profondita_max}</td>
                                <td>{sondaggio.has_eluato ? <Info label="Eluato">E</Info> : null}</td>
                                <td>{sondaggio.is_esodato ? <Info label="Esodato"><i className="fa-solid fa-clone"></i></Info> : null}</td>
                                <Next><i className="fas fa-chevron-right"></i></Next>
                            </Tr>
                        )}

                        {piezometri && piezometri.length > 0 &&
                            <Piezometri
                                items={piezometri}
                                onItemClick={id => onClickRow(piezometro(id))}
                                onMouseEnter={id => onMouseEnterRow(piezometro(id))}
                                onMouseOut={id => onMouseLeaveRow(piezometro(id))}
                            />
                        }
                    </tbody>
                </Table>
            </List>
        </Page>
    )
}